
import _ from 'lodash';
import moment from 'moment';

const namespaced = true;

const state = {
  interventionId: null,
  intervention: {},
  availableEquipments: [],
  linkedEquipments: [],
};

const mutations = {
  ADD_CLIENT_TAG_IN_INTERVENTION(state, tag) {
    const intervention = _.clone(state.intervention);
    intervention.clientTags = intervention.clientTags || [];
    intervention.clientTags.push(tag);
    state.intervention = intervention;
  },
  REMOVE_CLIENT_TAG_IN_INTERVENTION(state, tag) {
    const intervention = _.clone(state.intervention);
    intervention.clientTags = intervention.clientTags || [];
    const interventionIndex = _.findIndex(intervention.clientTags, { id: tag.id });
    if (interventionIndex > -1) {
      intervention.clientTags.splice(interventionIndex, 1);
    }
    state.intervention = intervention;
  },
  ADD_MAKER_TAG_IN_INTERVENTION(state, tag) {
    const intervention = _.clone(state.intervention);
    intervention.makerTags = intervention.makerTags || [];
    intervention.makerTags.push(tag);
    state.intervention = intervention;
  },
  REMOVE_MAKER_TAG_IN_INTERVENTION(state, tag) {
    const intervention = _.clone(state.intervention);
    intervention.makerTags = intervention.makerTags || [];
    const interventionIndex = _.findIndex(intervention.makerTags, { id: tag.id });
    if (interventionIndex > -1) {
      intervention.makerTags.splice(interventionIndex, 1);
    }
    state.intervention = intervention;
  },
  SET_INTERVENTION_ID(state, interventionId) {
    state.interventionId = interventionId;
  },
  SET_INTERVENTION(state, intervention) {
    state.intervention = intervention;
  },
  SET_AVAILABLE_EQUIPMENTS(state, equipments) {
    state.availableEquipments = equipments;
  },
  SET_LINKED_EQUIPMENTS(state, equipments) {
    state.linkedEquipments = equipments;
  },
};

const actions = {
  async addClientTag({ state, commit, dispatch }, tag) {
    try {
      await dispatch(`model/intervention/addClientTag`, {
        interventionId: state.interventionId,
        tagId: tag.id,
      }, { root: true });

      return commit(`ADD_CLIENT_TAG_IN_INTERVENTION`, tag);
    } catch (e) {
      return null;
    }
  },
  async removeClientTag({ state, commit, dispatch }, tag) {
    try {
      await dispatch(`model/intervention/removeClientTag`, {
        interventionId: state.interventionId,
        tagId: tag.id,
      }, { root: true });

      return commit(`REMOVE_CLIENT_TAG_IN_INTERVENTION`, tag);
    } catch (e) {
      return null;
    }
  },
  async addMakerTag({ state, commit, dispatch }, tag) {
    try {
      await dispatch(`model/intervention/addMakerTag`, {
        interventionId: state.interventionId,
        tagId: tag.id,
      }, { root: true });

      return commit(`ADD_MAKER_TAG_IN_INTERVENTION`, tag);
    } catch (e) {
      return null;
    }
  },
  async removeMakerTag({ state, commit, dispatch }, tag) {
    try {
      await dispatch(`model/intervention/removeMakerTag`, {
        interventionId: state.interventionId,
        tagId: tag.id,
      }, { root: true });

      return commit(`REMOVE_MAKER_TAG_IN_INTERVENTION`, tag);
    } catch (e) {
      return null;
    }
  },
  async fetchAvailableEquipments({ state, commit, dispatch }) {
    const queryParams = {
      client: state.intervention.Client_id,
      maker: state.intervention.Maker_id || undefined,
      site: state.intervention.Site_id,
      viewAll: 1,
    };

    const equipments = await dispatch(`model/equipment/fetchList`, {
      queryParams,
    }, { root: true });

    commit(`SET_AVAILABLE_EQUIPMENTS`, equipments);
  },
  async fetchLinkedEquipments({ state, commit, dispatch }) {
    const equipments = await dispatch(`model/equipment/fetchListForIntervention`, state.interventionId, { root: true });

    commit(`SET_LINKED_EQUIPMENTS`, equipments);
  },
  linkEquipment({ dispatch }, equipment) {
    return dispatch(`model/intervention/linkEquipment`, {
      interventionId: state.interventionId,
      equipmentId: equipment.id,
    }, { root: true });
  },
  unlinkEquipment({ dispatch }, equipment) {
    return dispatch(`model/intervention/unlinkEquipment`, {
      interventionId: state.interventionId,
      equipmentId: equipment.id,
    }, { root: true });
  },
  remove({ dispatch }) {
    return dispatch(`model/intervention/remove`, state.interventionId, { root: true });
  },
  // updatePlannedDate(store, { plannedStartAt, plannedEndAt, isPlannedHourly }) {
  updatePlannedDate({ dispatch }, { plannedStartAt, plannedEndAt, isPlannedHourly }) {
    const { interventionId } = state;
    plannedEndAt = plannedEndAt || plannedStartAt;
    const plannedDaysDuration = moment(plannedEndAt, `YYYYMMDDHHmm`).diff(moment(plannedStartAt, `YYYYMMDDHHmm`), `days`) + 1;
    return dispatch(`model/intervention/updatePlannedDate`, {
      interventionId,
      plannedStartAt,
      plannedDaysDuration,
      plannedEndAt,
      isPlannedHourly,
    }, { root: true });
  },
  addNote({ dispatch }, note) {
    const { interventionId } = state;
    return dispatch(`model/intervention/addNote`, { interventionId, note }, { root: true });
  },
  updateNote({ dispatch }, { id, note }) {
    return dispatch(`model/intervention/updateNote`, { id, note }, { root: true });
  },
};

const getters = {
  isAggregatorClient(state) {
    return Boolean(state.intervention.client && state.intervention.client.slug && state.intervention.client.slug.length);
  },
  isRealEstateClient(state, getters) {
    return Boolean(getters.isAggregatorClient && state.intervention.client.isRealEstate);
  },
};

export default {
  namespaced, state, mutations, actions, getters,
};
